import {FAILURE, PENDING, SUCCESS} from '../../constants'

export const RE_FAILURE = `GET_RESERVATION_RESOURCES_${FAILURE}`
export const RE_PENDING = `GET_RESERVATION_RESOURCES_${PENDING}`
export const RE_SUCCESS = `GET_RESERVATION_RESOURCES_${SUCCESS}`
